var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.003,
    height: 12.998,
    viewBox: "0 0 13.003 12.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_283",
    "data-name": "Subtraction 283",
    d: "M6.5,13A6.5,6.5,0,1,1,13,6.5,6.509,6.509,0,0,1,6.5,13ZM6.5,2.354a.587.587,0,0,0-.585.6V6.5a.58.58,0,0,0,.174.414L8.448,9.279a.6.6,0,0,0,.418.171.588.588,0,0,0,.418-.175.587.587,0,0,0,0-.832L7.092,6.255v-3.3a.591.591,0,0,0-.17-.431A.609.609,0,0,0,6.5,2.354Z",
    fill: "#f8f8f8",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockDark);
export default __webpack_public_path__ + "static/media/clock-dark.93b78e7355b4d1ec7d57685dac2b307b.svg";
export { ForwardRef as ReactComponent };